<template>
  <div id="app" class="cf">
    <topbar/>
    <router-view></router-view>
  </div>
</template>

<script>
import Topbar from 'components/Topbar'

export default {
  name: 'App',
  components: {
    Topbar
  },
}
</script>

<style lang="sass">
#app
  main
    &>*+*
      margin: 0 auto 40px
</style>



// WEBPACK FOOTER //
// src/App.vue